import React from "react";
import ButtonBase from "../_base/ButtonBase";
import styles from "./index.module.css";

const PrimaryButton = React.forwardRef(function PrimaryButton(props, ref) {
  return (
    <ButtonBase {...props} ref={ref} styles={styles} spinnerColor="#614600" />
  );
});

export default PrimaryButton;
